import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_grid _grid-cols-5 _gap-2 _jc-st _pa-3 _pa-5--m",
  "data-qa": "backer-center-payments:Skeleton"
}
const _hoisted_2 = { class: "_flexcol _col-span-4 _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_skeleton_line, { height: 22 }),
      _createVNode(_component_skeleton_line, { height: 18 })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_skeleton_line, { height: 22 })
    ])
  ]))
}